module.exports = "/virtual-football-league/img/amblems/right/logos/LEVANTE.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/LEVANTE.png
// module id = 2206
// module chunks = 4